module.exports = __webpack_public_path__ + "media/images/athletes/2501-dda88aedcff49372c27b13d6903cd6d2.png";